module.exports = __webpack_public_path__ + "static/Lovepik_com-400459210-hand-painted-camera-e407756e7ffd3e6cb45305630c0b05f0.png";